export enum CampaignName {
  FIRESHIP_2025 = 'FIRESHIP_2025',
  MADHAT_2025 = 'MADHAT_2025',
  THE_BEARDED_IT_DAD_2025 = 'THE_BEARDED_IT_DAD_2025',
  TYLER_RAMSBEY_2025 = 'TYLER_RAMSBEY_2025',
  LOGICALLY_2025 = 'LOGICALLY_2025',
  GRANT_COLLINS_2025 = 'GRANT_COLLINS_2025',
  FLASH_SALE_SUMMER_DEAL_2025 = 'FLASH_SALE_SUMMER_DEAL_2025',
  DFIR_2025 = 'DFIR_2025',
  TOASTY_BROS_2025 = 'TOASTY_BROS_2025',
  CREATED_TECH_2025 = 'CREATED_TECH_2025',
  ERIC_PARKER_2025 = 'ERIC_PARKER_2025',
}
